module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "EBOOK INSTRUCTIONS"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pz5-1ab"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#ba_01",
      "id": "ab_01"
    }
  }, [_c('b', [_vm._v("EBOOK INSTRUCTIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind_aa1"
  }, [_vm._v("In this ebook edition, please use your device’s note-taking function to record your thoughts wherever you see the bracketed instructions [Your Notes] or [Your Response Here]. Use your device’s highlighting function to record your response whenever you are asked to checkmark, circle, underline, or otherwise indicate your answer(s).")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8c2317","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/instructions.vue
// module id = 66
// module chunks = 0